(() => {
  'use strict';

  /* theme.liquid loads this asset only for the exact Shopify page handle. */
  if (window.__nuoraO20bUpcartGiftHelper) return;
  window.__nuoraO20bUpcartGiftHelper = true;

  const LINE_SELECTOR = '#UpcartPopup li.upcart-public-cart-item, #CartPopup li.upcart-public-cart-item';
  const PRICE_SELECTOR = '.upcart-public-component-product-tile__price';
  const LINK_SELECTOR = [
    '.upcart-public-component-product-tile__image-wrapper[href]',
    '.upcart-public-component-product-tile__title-link[href]'
  ].join(',');
  const CONTROL_SELECTOR = [
    '.upcart-public-component-product-tile__quantity-plus',
    '.upcart-public-component-product-tile__quantity-minus',
    '.upcart-public-component-product-tile__quantity-selector',
    '.upcart-public-component-product-tile__controls',
    'input[aria-label="Product quantity"]'
  ].join(',');
  const BLOCKED_ACTION_SELECTOR = `${LINK_SELECTOR},${CONTROL_SELECTOR}`;
  let frame = 0;

  function isZeroPriceLine(line) {
    if (!line?.matches?.('li.upcart-public-cart-item')) return false;
    const priceText = line.querySelector(PRICE_SELECTOR)?.textContent || '';
    const digits = priceText.match(/\d/g);
    return Boolean(digits?.length) && digits.every((digit) => digit === '0');
  }

  function decorateLine(line) {
    line.setAttribute('data-nuora-locked-gift-line', '');
    line.querySelectorAll(LINK_SELECTOR).forEach((link) => {
      link.setAttribute('aria-disabled', 'true');
      link.setAttribute('tabindex', '-1');
      link.setAttribute('draggable', 'false');
    });
    line.querySelectorAll('.upcart-public-component-product-tile__controls').forEach((controls) => {
      controls.setAttribute('aria-hidden', 'true');
    });

    if (line.querySelector('.nuora-cart-gift-badge')) return;
    const badge = document.createElement('span');
    badge.className = 'nuora-cart-gift-badge';
    badge.textContent = 'FREE GIFT';
    badge.setAttribute('aria-label', 'Free gift. Quantity fixed at one.');
    const controls = line.querySelector('.upcart-public-component-product-tile__controls');
    if (controls?.parentNode) controls.parentNode.insertBefore(badge, controls);
  }

  function clearDecoration(line) {
    line.removeAttribute('data-nuora-locked-gift-line');
    line.querySelectorAll(LINK_SELECTOR).forEach((link) => {
      link.removeAttribute('aria-disabled');
      link.removeAttribute('tabindex');
      link.removeAttribute('draggable');
    });
    line.querySelectorAll('.upcart-public-component-product-tile__controls').forEach((controls) => {
      controls.removeAttribute('aria-hidden');
    });
    line.querySelectorAll('.nuora-cart-gift-badge').forEach((badge) => badge.remove());
  }

  function decorateCart() {
    document.querySelectorAll(LINE_SELECTOR).forEach((line) => {
      if (isZeroPriceLine(line)) {
        decorateLine(line);
        return;
      }
      clearDecoration(line);
    });
  }

  function queueDecoration() {
    if (frame) return;
    frame = window.requestAnimationFrame(() => {
      frame = 0;
      decorateCart();
    });
  }

  function touchesUpcart(mutation) {
    const target = mutation.target?.nodeType === 1 ? mutation.target : mutation.target?.parentElement;
    if (target?.closest?.('#UpcartPopup, #CartPopup')) return true;
    return [...mutation.addedNodes].some((node) => node.nodeType === 1 && (
      node.matches?.('#UpcartPopup, #CartPopup, li.upcart-public-cart-item') ||
      node.querySelector?.('#UpcartPopup, #CartPopup, li.upcart-public-cart-item')
    ));
  }

  const observer = new MutationObserver((mutations) => {
    if (mutations.some(touchesUpcart)) queueDecoration();
  });

  function blockZeroPriceAction(event) {
    const action = event.target?.closest?.(BLOCKED_ACTION_SELECTOR);
    const line = action?.closest?.('li.upcart-public-cart-item');
    if (!action || !isZeroPriceLine(line)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  ['pointerdown', 'click', 'auxclick', 'dragstart', 'beforeinput', 'input', 'change', 'keydown'].forEach((eventName) => {
    document.addEventListener(eventName, blockZeroPriceAction, true);
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  queueDecoration();
})();
